import update from 'immutability-helper';
import reduceReducers from 'reduce-reducers';
import I18n from 'app/common/i18n';
import {assessments} from 'app/client/api';
import {showAppBusy, handleAppError} from './app';


const initialState = {
	assessments: []
}

const RECEIVE_ASSESSMENTS = 'candidates/RECEIVE_ASSESSMENTS';

function receiveAssessments(payload) {
	return {type: RECEIVE_ASSESSMENTS, payload}
}

export function fetchAssessments() {
  return async dispatch => {
  	dispatch(showAppBusy(true));
    try {
      let response = await assessments();
      dispatch(receiveAssessments(response.data.assessments));
      dispatch(showAppBusy(false));
    } catch(exception) {
    	dispatch(showAppBusy(false));
    	dispatch(handleAppError(exception, I18n.t('errors.unexpected')));
    }
  }
}


export default function reducer(state = initialState, action) {
	let {	type, payload	} = action;
	switch(type)	{

		case RECEIVE_ASSESSMENTS:
			return update(state, {assessments: { $set: payload }});

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/sessions.js